// Lógica única para el estado de un lead.
// Usado por LeadForm, LeadsList y (próximamente) el form público.
//
// Reglas:
//   - Sin fecha de contacto                  → ""
//   - Sin resultado o sin fecha de resultado → "pendiente"
//   - resultado "rechazado"                  → "perdido"
//   - resultado "cliente" | "recuperado"     → "convertido"
//   - resultado "lista_espera"               → "lista_espera"

export const ESTADOS = ["pendiente", "convertido", "perdido", "lista_espera"];

export const RESULTADO_OPTIONS = [
  { value: "cliente", label: "Cliente" },
  { value: "recuperado", label: "Recuperado" },
  { value: "rechazado", label: "Rechazado" },
  { value: "lista_espera", label: "Lista Espera" },
];

export const ESTADO_LABELS = {
  pendiente: "Pendiente",
  convertido: "Convertido",
  perdido: "Perdido",
  lista_espera: "Lista Espera",
};

export const ESTADO_COLORS = {
  pendiente: "bg-gray-100 text-gray-700",
  convertido: "bg-emerald-100 text-emerald-700",
  perdido: "bg-red-100 text-red-700",
  lista_espera: "bg-amber-100 text-amber-700",
};

// Tonos suaves para pintar la fila completa del lead en el listado.
// "pendiente" se mantiene neutro para no saturar la UI.
export const ESTADO_ROW_COLORS = {
  pendiente: "hover:bg-gray-50",
  convertido: "bg-emerald-100/70 hover:bg-emerald-100",
  perdido: "bg-red-100/60 hover:bg-red-100",
  lista_espera: "bg-amber-100/60 hover:bg-amber-100",
};

export function calcularEstado(resultado, fechaResultado, fechaContacto) {
  if (!fechaContacto) return "";
  if (!resultado || resultado === "pendiente" || !fechaResultado) return "pendiente";
  if (resultado === "rechazado") return "perdido";
  if (resultado === "cliente" || resultado === "recuperado") return "convertido";
  if (resultado === "lista_espera") return "lista_espera";
  return "pendiente";
}

export function calcularEstadoFromLead(lead) {
  return calcularEstado(lead.resultado, lead.fecha_resultado, lead.fecha_contacto);
}
